import type { ReactElement } from 'react';
import { MonthRangeFilterChip } from 'components/filters/MonthRangeFilterChip';
import { usePeriod } from 'modules/reporting/usePeriod';

export function PeriodFilter(): ReactElement {
  const { date_from: minDate, date_to: maxDate } = usePeriod();

  return (
    <MonthRangeFilterChip label="Period" fromName="date_from" toName="date_to" minDate={minDate} maxDate={maxDate} />
  );
}
